import React from 'react';
import { useWatch } from 'react-hook-form';
import { useExpenseReceiptTypeIdInputQuery } from '../../../../../../../services';
import { RhCheckbox } from '../../../../../../dum';
import {
    IExpense,
    REQUIRE_EXTERNAL_CODE,
} from '../expense-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

export function ExpenseRequireExternalCodeInput() {
    const { data } = useExpenseReceiptTypeIdInputQuery();
    const receiptTypeId = useWatch({
        name: 'receipt_type_id',
    }) as IExpense['receipt_type_id'];
    const receiptType = (data?.getReceiptTypes ?? []).find(
        (type) => type.id === receiptTypeId,
    );

    return (
        <RhCheckbox
            name={REQUIRE_EXTERNAL_CODE}
            label={shortLabel(FIELD_LABELS.require_external_code)}
            disabled={!!receiptType && !receiptType.applies_tax}
        />
    );
}
